// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Component } from './component';
import { createComponent, render } from './common';

/**
 * @class Jsw.Container
 * @extends Jsw.Component
 */
export const Container = Class.create(Component, {
    /**
     * @cfg {Array} items
     */

    _initConfiguration($super, config) {
        $super(config);

        this._contentAreaId = this._id;

        this._initItems();
    },

    _initItems(items) {
        items = items || this._getConfigParam('items') || [];

        this._items = items.filter(function (item) {
            return !!item;
        }).map(createComponent);
    },

    _renderItems() {
        this._items.forEach(this._renderItem, this);
    },

    _renderItem(item) {
        render($(this._contentAreaId), item);
    },

    render($super) {
        $super();

        this._renderItems();
    },

    getItems() {
        return this._items;
    },

    getItem(id) {
        return this.getItems().find(function (item) {
            return item.getId() === id;
        });
    },
});



// WEBPACK FOOTER //
// ./jsw/container.js